import { Item, Model } from '@vuex-orm/core'
import Booking from '@/models/user/Booking'

export default class Customer extends Model {
  declare id: number
  declare bookingId: string
  declare booking: Booking
  declare title: string
  declare firstName: string
  declare middleName: string
  declare surName: string
  declare street: string
  declare addressSuffix: string
  declare postcode: string
  declare city: string
  declare region: string
  declare country: string
  declare dob: string
  declare language: string
  declare email: string
  declare phoneCountryDialCode: string | null
  declare phoneCountryCodeIso: string | null
  declare phoneNumber: string | null
  declare viaEmail: boolean
  declare viaMobilePhone: boolean
  declare registerParticipants: boolean
  declare prefersToCreateRekaAccount: boolean
  declare isEmailAndPhoneExternallyValidated: boolean

  static entity = 'customers'

  static fields() {
    return {
      id: this.attr(null),
      bookingId: this.attr(''),
      booking: this.belongsTo(Booking, 'bookingId'),
      title: this.attr(''),
      firstName: this.attr(''),
      middleName: this.attr(''),
      surName: this.attr(''),
      street: this.attr(''),
      addressSuffix: this.attr(''),
      postcode: this.attr(''),
      city: this.attr(''),
      region: this.attr(''),
      country: this.attr('CH'),
      dob: this.string(''),
      language: this.attr(''),
      email: this.attr(''),
      phoneCountryDialCode: this.attr('').nullable(),
      phoneCountryCodeIso: this.attr('').nullable(),
      phoneNumber: this.attr('').nullable(),
      viaEmail: this.boolean(false),
      viaMobilePhone: this.boolean(false),
      registerParticipants: this.boolean(false),
      prefersToCreateRekaAccount: this.boolean(false),
      isEmailAndPhoneExternallyValidated: this.boolean(false)
    }
  }

  static getCustomer(): Item<Customer> {
    return this.query().first()
  }

  static modifyCustomer(data: Partial<Customer>) {
    if (!Object.keys(data).length) return

    return this.update({
      where: () => true,
      data
    })
  }

  static isSwissCustomer() {
    const customer = this.getCustomer()
    return customer?.country?.toLowerCase() === 'ch'
  }

  static isGermanCustomer() {
    const customer = this.getCustomer()
    return customer?.country?.toLowerCase() === 'de'
  }
}
